import type { applyPureReactInVue } from 'veaury';

type ReactWrapperOptions = NonNullable<Parameters<typeof applyPureReactInVue>[1]>;

// NOTE: https://github.com/gloriasoft/veaury/blob/master/src/options.js#L45
export const reactWrapperOptions: ReactWrapperOptions = {
  react: {
    componentWrapAttrs: {
      style: {
        // Remove the hardcoded `all: "unset"`
        all: '',
        // Ensure the wrapper doesn't interfere with the layout of the React component
        display: 'contents',
      },
    },
  },
};
